




import { Component, Vue } from "vue-property-decorator";
import Databases from "@/components/Databases.vue"; // @ is an alias to /src

@Component({
  components: {
    Databases
  }
})
export default class DatabasesPage extends Vue {}
